import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { classNames } from '@/lib/format';

export const KpiCard = ({ label, value, delta, caption, icon: Icon, accent, to, ...rest }) => {
  const card = (
    <Card
      {...rest}
      className={classNames(
        'card-elevated border-border/60',
        to && 'transition-colors hover:border-primary/40 hover:bg-accent/30',
      )}
    >
      <CardContent className="p-5">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</p>
            <p className="mt-2 text-3xl font-semibold tabular-nums">{value}</p>
          </div>
          {Icon && (
            <div className={classNames('grid h-10 w-10 place-items-center rounded-lg border bg-secondary/60')}>
              <Icon className="h-5 w-5 text-foreground/70" />
            </div>
          )}
        </div>
        <div className="mt-3 flex items-center gap-2 text-xs">
          {delta && (
            <span
              className={classNames(
                'rounded-full px-2 py-0.5 font-medium',
                accent === 'down' ? 'bg-rose-50 text-rose-700' : 'bg-emerald-50 text-emerald-700',
              )}
            >
              {delta}
            </span>
          )}
          <span className="text-muted-foreground">{caption}</span>
        </div>
      </CardContent>
    </Card>
  );

  if (to) {
    return (
      <Link
        to={to}
        className="block rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {card}
      </Link>
    );
  }

  return card;
};
